import { render, staticRenderFns } from "./ManuscriptPreview.vue?vue&type=template&id=ec33dc36&scoped=true"
import script from "./ManuscriptPreview.vue?vue&type=script&lang=ts"
export * from "./ManuscriptPreview.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptPreview.vue?vue&type=style&index=0&id=ec33dc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec33dc36",
  null
  
)

export default component.exports